{
    "NAME": "CodeAddModify",
    "GeneralTitle": "Geral",
    "ScopeAssignmentTitleTitle": "Atribuição do âmbito de aplicação",
    "AddUserTitle": "Adicionar código",
    "ModifyCodeTitle": "Modificar código",
    "GUID": "IDENTIFICADOR (GUID):",
    "GUIDPlaceholder": "[Gerado automaticamente]",
    "Code": "Código:",
    "CodeType": "Tipo de código:",
    "CodeTypeHelp": "Determina o tipo do novo código",
    "CodeTypeOptionOne": "Conta\/autorização",
    "CodeTypeOptionTwo": "ACD Indisponível",
    "CodeTypePlaceholder": "Conta\/autorização",
    "Description": "Descrição:",
    "UpdateExisting": "Atualizar itens duplicados:",
    "TelServer": "Servidor de telefonia",
    "Partition": "Partição",
    "CodeAddModify_AccountAuthorisation": "Conta\/autorização",
    "CodeAddModify_ACDNotAvailable": "ACD Indisponível",
    "CodeAddModify_ErrorMessage_Server_Error": "Erro do servidor",
    "CodeAddModify_ErrorMessage_Successful": "Sucesso",
    "CodeAddModify_ServerErrorTitle": "Erros de validação",
    "CodeAddModify_ValidationWarning": "Certifique-se de que todos os campos estão corretamente preenchidos",
    "CodeAddModify_ButtonHelpLabel": "Ajuda?",
    "CodeAddModify_ButtonSubmitLabel": "Guardar",
    "CodeAddModify_ButtonCancelLabel": "Cancelar",
    "CodeAddModify_PromptMessage": "Tem a certeza de que pretende fechar esta janela? Todas as configurações modificadas serão perdidas ao fechá-la.",
    "CodeAddModify_PromptConfirm": "Sim",
    "CodeAddModify_PromptCancel": "Cancelar",
    "CodeAddModify_DetailsTitle": "Detalhes do utilizador",
    "CodeAddModify_ValidationError": "Erro de validação",
    "Errors_Code_Required": "Este campo é obrigatório",
    "Errors_Code_Validation": "Formato válido necessário: 1, 3-5",
    "Errors_CodeAddModify_Code_Length": "O nome de código deve ter menos de 100 caracteres",
    "Errors_CodeAddModify_Description_Length": "A descrição deve ter menos de 100 caracteres"
}